import { makeAutoObservable } from 'mobx';
import Subjects from '../../models/subjects';
import ITaskCriteria from '../../models/task-criteria';
import NumberInKimFilterStore from '../common/number-in-kim-filter';
import SourceFilterStore from '../common/source-filter';
import TagsStore from '../common/tags-filter';
import TextFilter from '../common/text-filter';
import ThemeFilterStore from '../common/theme-filter';

export default class TaskFilterStore {

    source: SourceFilterStore;
    theme: ThemeFilterStore;
    numberInKim: NumberInKimFilterStore;
    tags: TagsStore;
    textFilter: TextFilter;

    withSolution: boolean = false;
    taskId: number | null;

    constructor(subject: Subjects) {

        this.source = new SourceFilterStore(subject);
        this.numberInKim = new NumberInKimFilterStore(subject);
        this.theme = new ThemeFilterStore(subject);
        this.tags = new TagsStore(subject);
        this.textFilter = new TextFilter();
        this.withSolution = false;
        this.taskId = null;

        makeAutoObservable(this);
    }

    changeWithSolution(value: boolean): void {
        this.withSolution = value;
    }

    changeTaskId(value: number | null) {
        this.taskId = value;
    }

    clear() {
        this.source.reset();
        this.numberInKim.reset();
        this.theme.reset();
        this.tags.reset();
        this.textFilter.changeSearchText("");
        this.taskId = null;
        this.withSolution = false;
    }

    printFilters(): void {
        console.log('====================================');
        console.log('source: ' + this.source.selectedItems);
        console.log('theme: ' + this.theme.selectedItems);
        console.log('numberInKim: ' + this.numberInKim.selectedItems);
        console.log('tags: ' + this.tags.selectedItems);
        console.log('text: ' + this.textFilter.text);
        console.log('withSolution: ' + this.withSolution);
        console.log('taskId: ' + this.taskId);
    }

    get getCriteria(): ITaskCriteria {
        return {
            sources: this.source.selectedItems,
            numbersInKim: this.numberInKim.selectedItems,
            themes: this.theme.selectedItems,
            withSolution: this.withSolution,
            text: this.textFilter.text,
            tags: this.tags.selectedItems,
            taskId: this.taskId || undefined
        } as ITaskCriteria;
    }
}